import { useLocation, useNavigate } from "react-router-dom";

export const usePerformanceReviewRespond = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const exit = () => {
    if (location.state?.from) navigate(location.state.from);
    else navigate(`/`);
  };

  return {
    exit,
  };
};
